<ng-container *ngIf="notification">
  <section class="notification">
    <div class="notification__content">
      <mat-icon class="notification__content-icon material-symbols-outlined">report</mat-icon>

      <div class="notification__content-text">
        <span class="notification__content-text--highlight">Warning - Trip ID {{ notification.trip }}</span>
        <span>
          {{ notification.notificationDetail }}
        </span>
      </div>
    </div>

    <div class="notification__actions">
      <a mat-ripple
         class="btn-dark flex-center notification__actions-view"
         aria-label="View Service Request"
         (click)="onViewServiceRequest()"
      >
        View
      </a>
      <button type="button"
              mat-ripple
              class="btn-light"
              *ngIf="!showSnoozeDropDown"
              (click)="onShowDropDown()"
      >
        <img ngSrc="assets/icons/v2/clock-z.svg" height="16" width="18" alt="snooze" >
      </button>
      <div class="dropdown" *ngIf="showSnoozeDropDown">
        <mat-select [(ngModel)]="snoozeTime"
                    class="control-dropdown time-range-dropdown"
                    panelClass="select-v2-panel"
                    aria-labelledby="title"
                    placeholder="Select time"
                    (ngModelChange)="onSnoozeTimeChange($event.value)"
        >
          <mat-option
            *ngFor="let time of snoozeTimeRange"
            [value]="time">
            {{ time.label }}
          </mat-option>
        </mat-select>
      </div>
      <button mat-ripple class="btn-light"
              (click)="closeNotification()">Dismiss
      </button>
    </div>
  </section>
</ng-container>
